import React from "react";
import { MyGroup } from ".";
import { useGroup } from "../context/GroupContext";

const MyGroups = () => {

  const { myGroups } = useGroup();

  return (
    <>
      {(myGroups && myGroups?.length > 0) ? <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {myGroups.map((group) => (
          <MyGroup data={group} button="View" />
        ))}
      </div> : <div className="h-full mt-8 flex justify-center flex-col items-center">
        <h4 className="text-center">
          No Records Yet
        </h4>
      </div>}
    </>
    
  );
};

export default MyGroups;
